import palette from '../palette';

const MuiTextField = {
  root: {
    color: palette.text.primary,
  },
};

export default MuiTextField;
